import React, { createContext, useContext, useMemo, useState } from "react";
import { IntlProvider } from "react-intl";
import en from "../../i18n/en.json";
import th from "../../i18n/th.json";
const DEFAULT_LOCALE = "en";
const uiKitTranslations = {
    en,
    th,
};
const LocaleContext = createContext(null);
export const useLocale = () => useContext(LocaleContext);
function LocaleProvider({ messages, children, defaultLocale = DEFAULT_LOCALE, debug, }) {
    const [currentLocale, setCurrentLocale] = useState(defaultLocale);
    const handleChangeLocale = (locale) => {
        setCurrentLocale(locale);
    };
    const providerValue = {
        locale: currentLocale,
        setLocale: handleChangeLocale,
    };
    const allMessages = useMemo(() => ({
        // Translations built in to ui-kit
        ...(uiKitTranslations[currentLocale] || {}),
        // Translations from application using this provider.
        ...((messages === null || messages === void 0 ? void 0 : messages[defaultLocale]) || {}),
        ...((messages === null || messages === void 0 ? void 0 : messages[currentLocale]) || {}),
    }), [messages, currentLocale, defaultLocale]);
    if (debug) {
        // eslint-disable-next-line no-console
        console.groupCollapsed("LocalProvider");
        // eslint-disable-next-line no-console
        console.log("locale", currentLocale);
        // eslint-disable-next-line no-console
        console.log("messages", allMessages);
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
    return (React.createElement(LocaleContext.Provider, { value: providerValue },
        React.createElement(IntlProvider, { locale: currentLocale, messages: allMessages, defaultLocale: defaultLocale }, children)));
}
LocaleProvider.defaultProps = {
    defaultLocale: DEFAULT_LOCALE,
    messages: {},
};
export default LocaleProvider;
//# sourceMappingURL=index.js.map